export default function useGetOnlyDescription({ description }) {
  return description ?? '';
}
